import React, { useState, useEffect } from 'react'
import { Fade, Modal } from '@mui/material'
import View from '@modul-connect/shared/components/atoms/view'
import Button from '@modul-connect/shared/components/atoms/button'
import { H1 } from '@modul-connect/shared/components/atoms/text'
import modal from '@modul-connect/shared/components/atoms/modal'
import TreeWidget from '@modul-connect/shared/components/molecules/treeWidget'
import { RoleExplanation } from './roleExplanation'

export const EditPrivilegeModal = ({ openModal, onClose, disabled, user, onSubmit }) => {
  const [selectedRole, setSelectedRole] = useState(user?.privilege || null)

 
  useEffect(() => {
    if (openModal && user?.privilege) {
      setSelectedRole(user.privilege)
    }
  }, [openModal, user?.privilege])

  const rolesTree = {
    children: [
      { uuid: 'fleet manager', name: 'Manager' },
      { uuid: 'standard', name: 'User' },
    ]
  }

  const onSave = () => {
    if (!selectedRole)
      return
      
    onSubmit({
      ...user,
      privilege: selectedRole
    })

  }
  
  return(
    <Modal
      open={openModal}
      onClose={(event, reason) => {
        if (disabled && reason === 'backdropClick') {
          return
        } 
        onClose()
      }}
    >
      <Fade in={openModal}>
        <div>
          <View extend={modal.container}>
            <View extend={modal.header}>
              <H1 text="Edit user role" />
            </View>
            <TreeWidget
              title={'Select role'}
              tree={rolesTree}
              disabled={disabled}
              selected={selectedRole}
              hideRoot={true}
              rootDisabled={false}
              onSelect={(uuid, name) => {
                setSelectedRole(uuid)

              }}
            />
            <RoleExplanation/>

            <View extend={modal.footer}>
              <Button noBg disabled={disabled} cancel onClick={onClose}>
              Cancel
              </Button>
              <Button noBg disabled={disabled} noPadding onClick={onSave}>
              Submit
              </Button>
            </View>
          </View>
        </div>
      </Fade>
    </Modal>

  )
}